import Vue from "vue";
const { $gettext } = Vue.prototype;
import Storage from "@/utils/storage";
import {
  LIST_AREA,
  SET_COURSE_DETAIL,
  SET_COURSE_REVIEW_TOTAL,
} from "../mutation-types";
import GolfCourseService from "@/services/GolfCourseService";
import CommonService from "@/services/CommonService";
const golfcourse = {
  state: () => ({
    courseDetail: {},
    availableZoneAndCountry: Storage.get('availableZoneAndCountry' + CommonService.currentLanguage(), '[]')
  }),
  getters: {},
  mutations: {
    [LIST_AREA](state, listData) {
      state.listArea = listData;
    },
    [SET_COURSE_DETAIL](state, value) {
      state.courseDetail = value;
    },
    [SET_COURSE_REVIEW_TOTAL](state, value) {
      state.courseReviewTotal = value;
    },
  },
  actions: {
    async getListCourse({state}, data) {
      const result = await GolfCourseService.getTopGolfCourse({
        page: data.page,
        country: data.country || null,
        zone: data.zone || null
      });
      return result
    },
    async requestAdminGolfCourse({}, data) {
      const result = await GolfCourseService.requestAdminGolfCourse(data);
      if (result) {
        return result;
      } else {
        return true;
      }
    },
    async editInfoGolfClub({}, data) {
      const result = await GolfCourseService.updateInfoCourse(data);
      if (result) {
        return result;
      } else {
        return true;
      }
    },
    async searchCourse({state}, data) {
      const input = {
        page: data.page || null,
        value: data.text || null,
        countryId: (state.currentCountry && state.currentCountry.id) || null,
        cityId: data.city ? (data.city.id || data.city) : null,
        stateId: data.state ? (data.state.id || data.state) : null
      }
      if(data.limit) {
        input.limit = data.limit
      }
      return await GolfCourseService.searchGolfCourses(input);
    },
    async searchUser({ commit, state }, val) {
      const result = await GolfCourseService.searchUser({
        page: val.page,
        value: val.text,
        countryId: state.currentCountry ? state.currentCountry.id : null,
      });
      return result
    },
    async getDetailCourse({ state, commit }, slug) {
      let result = await GolfCourseService.getCourseById(
        slug || state.idSearch
      );
      commit(SET_COURSE_DETAIL, result)
    },
    async getCourseReview({ }, { id, page, limit, lang }) {
      return await GolfCourseService.getCourseReview(id, page, limit, lang);
    },
    async deleteCourseReview({}, key) {
      return await GolfCourseService.deleteCourseReview(key);
    },
    async updateCourseReview({}, key) {
      return await GolfCourseService.updateCourseReview(key);
    },
    async newCourseReview({}, data) {
      return await GolfCourseService.newCourseReview(data);
    },
    async getCourseReviewTotal({}, key) {
      return await GolfCourseService.getCourseReviewTotal(key);
    },
    async getCourseReviewLanguage({ }, id) {
      return await GolfCourseService.getCourseReviewLanguage(id);
    },
    async updateInterview({ commit }, data) {
      return await GolfCourseService.updateInterview(data);
    },
    async addCoursePlayer({ commit }, data) {
      return await GolfCourseService.addCoursePlayer(data);
    },
    async updateAvatarCourse({ state }, data) {
      let avatar = await GolfCourseService.updateInfoCourse({id: state.courseDetail.id, websiteLogo: data});
      if(avatar && !avatar.error) state.courseDetail.picture = avatar.picture;
      return avatar
    },
    async updateCoverCourse({ state }, data) {
      return await GolfCourseService.updateInfoCourse({id: state.courseDetail.id, websiteBanner: data});
    },

    async updateCourse({}, data) {
      const res = await GolfCourseService.updateInfoCourse(data);
      return res
    },
    async updateCoursePeers({}, data) {
      const res = await GolfCourseService.updateCoursePeers(data);
      return res
    },
    async fetchAvailableZoneAndCountry({state, rootState}, force = false) {
      if(state.availableZoneAndCountry.length > 0 && force === false) return;
      if(rootState.toggle.callAPIList.indexOf('fetchAvailableZoneAndCountry') !== -1) return
      rootState.toggle.callAPIList.push('fetchAvailableZoneAndCountry')
      const result = await GolfCourseService.getAreaCountryAvailable();
      const index = rootState.toggle.callAPIList.indexOf('fetchAvailableZoneAndCountry');
      if (index > -1) {
        rootState.toggle.callAPIList.splice(index, 1);
      }
      result.unshift({name: $gettext('Worldwide'), slug: 'worldwide'})
      state.availableZoneAndCountry = result
      Storage.set('availableZoneAndCountry' + CommonService.currentLanguage(), JSON.stringify(result))
      return true
    },
    async getCountryBySlug({}, slug) {
      return await GolfCourseService.getCountryBySlug(slug);
    },
    async getZoneBySlug({}, slug) {
      return await GolfCourseService.getZoneBySlug(slug);
    },
  },
};

export default golfcourse;
